import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { setCohorts } from "../features/cohort/cohortSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  setMenuCohorts,
  setAllCohorts
} from "../features/cohort/cohortSlice";

import api from "../services/api";
// import { MOCK_COHORT_PREVIEWS } from "../config/mockResponses";

const truncate = (text, length = 28) => {
  if (text.length <= length) return text;
  return text.substring(0, length) + "...";
};

// GROUP BY trace_id AND PICK EARLIEST created_at
const groupByTraceId = (items = []) => {
  const map = {};

  items.forEach(item => {
    if (!map[item.trace_id]) {
      map[item.trace_id] = [];
    }
    map[item.trace_id].push(item);
  });

  return Object.values(map).map(group =>
    group.sort(
      (a, b) =>
        new Date(a.created_at) - new Date(b.created_at)
    )[0]
  );
};

export default function Sidebar() {
  const role = useSelector(state => state.auth.role);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const cohorts = useSelector(state => state.cohort.menu);

  // FETCH BUSINESS COHORT LIST
  useEffect(() => {
    const fetchCohorts = async () => {
      const res = await api.get(
        "https://aidemo.fusionsystemsinc.com/api/v1/business/cohorts"
      );

      const items = res.data.items || [];

      dispatch(setAllCohorts(items));

      const grouped = {};
      items.forEach(item => {
        if (
          !grouped[item.trace_id] ||
          new Date(item.created_at) <
            new Date(grouped[item.trace_id].created_at)
        ) {
          grouped[item.trace_id] = item;
        }
      });

      // if (role === "business") {
      dispatch(setMenuCohorts(Object.values(grouped)));
      // }
    };

    fetchCohorts();
  }, [role, dispatch]);

  // BUSINESS SIDEBAR
  // if (role === "business") {
  return (
    <div className="sidebar">
      {/* NEW COHORT */}
      <div
        className="menu-link new-chat"
        onClick={() => navigate("/admin/materialize")}
      >
        <i className="fa-solid fa-gears" style={{ marginRight: 8 }}></i>
        Materialize Cohort
      </div>
      <div
        className="menu-link new-chat"
        onClick={() => navigate("/systemprompt")}
      >
        <i className="fa-solid fa-keyboard" style={{ marginRight: 8 }}></i>
        System Prompt
      </div>
      <div
        className="menu-link new-chat"
        onClick={() => navigate("/cohort")}
      >
        <i className="fa-solid fa-plus" style={{ marginRight: 8 }}></i>
        Cohort
      </div>

      {/* COHORT HISTORY */}
      <div className="sidebar-title">Cohort List</div>

      <ul className="menu">
        {cohorts.map(cohort => (
          <li key={cohort.trace_id}>
            <div
              className="menu-link"
              title={cohort.cohort_name}
              onClick={() =>
                navigate(`/cohort/${cohort.trace_id}`)
              }
            >
              {truncate(cohort.cohort_name)}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
  // }

  // ADMIN SIDEBAR
  // return (
  //   <div className="sidebar">
  //     <div className="sidebar-title">Admin</div>
  //       <ul className="menu">
  //         <li className="menu-link" onClick={() => navigate("/admin/cohorts-approval")}>
  //           Cohorts Approval
  //         </li>
  //         <li className="menu-link" onClick={() => navigate("/admin/materialize")}>
  //           Materialize Cohort
  //         </li>
  //         <li className="menu-link disabled">Audit Logs</li>
  //       </ul>
  //   </div>
  // );
}
